import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/trainer/batches/$batchId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/trainer/batches/$batchId/overview',
      params,
    });
  },
});
